import React from 'react'

import { AppsStreamlabsView } from './AppsStreamlabsView'
import { useStreamlabs } from './hooks/useStreamlabs'

export const AppsStreamlabsContainer = () => {
  const { streamlabs } = useStreamlabs()

  return <AppsStreamlabsView connectBar={streamlabs.connectBar} />
}
